import React from 'react';
import { Typography, Breadcrumbs, Box } from '@material-ui/core';

/*styles */
import useStyles from '../../styles';

/*components */
import { TransferInputTable } from './Components/TransferInputTable';

export default function TransferInput(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.pageContainer}>
        <div>
          <Typography
            variant="h2"
            className={classes.textBold}
            align="left"
            gutterBottom={true}
          >
            Full - Transfer Input
          </Typography>
          <Breadcrumbs aria-label="breadcrumb">
            <span color="inherit">Position</span>
            <span color="inherit">ACATS</span>
            <Typography color="primary">Full</Typography>
          </Breadcrumbs>
        </div>
        <Box mt={2}>
          <TransferInputTable params={props} />
        </Box>
      </div>
    </React.Fragment>
  );
}
